/**
 * Featured Products Block.
 * 
 */

/**
 * Desktop: Product chips appear in flex container (4-column).
 * Mobile: Centered 1-slide slick slider.
 */

// Set up slick slider for product slides in mobile.
let 
	$window = $(window),
	$mySlider = $('.featured-products__wrap'),
    mySliderSettings = {
    	centerMode:true,
    	centerPadding:'90px',
    	cssEase:'ease-out',
        infinite:true,
        mobileFirst:true,
        slidesToShow:1,
        swipeToSlide:true,
        // slidesToScroll:1,
        arrows:false,
        // adaptiveHeight:true,
        // responsive: [
        //     {
        //         breakpoint:767,
        //         settings: "unslick"
        //     }
        // ]
    };

function initMobileSlider() {
    console.log('FEATURED PRODUCTS: initMobileSlider()');
    $mySlider.slick(mySliderSettings);
}

function initResizeWatcher() {
	console.log('FEATURED PRODUCTS: initResizeWatcher()');

	$window.on('resize', function() {
		if ($window.width() >= 768) {
			console.log('FEATURED PRODUCTS: tablet-v');
			if ($mySlider.hasClass('slick-initialized')) {
				console.log('FEATURED PRODUCTS: UNSLICK');
				$mySlider.slick('unslick');
			}
			return
		}
		if (!$mySlider.hasClass('slick-initialized')) {
			console.log('FEATURED PRODUCTS: SLICK');
			$mySlider.slick(mySliderSettings);
		}
	});
}

exports.init = function () {
    // Run init methods...
    let browserW = $(window).width();

    // Initialize slick slider if page opened in mobile view (< 768).
    if (browserW < 768) {
	    initMobileSlider();
	}
	initResizeWatcher();
};